module.exports = __webpack_public_path__ + "static/media/VEMAS.cb5c2ba3.png";